import styled from 'styled-components';

import { PLAYERS, ANIM, MOBILE } from '../../../../theme/tokens';
import { Text } from '../../../../components';

// The whole bar: rows-per-page + range on the left, the pager on the right. Wraps
// on narrow widths so the 48px controls never overflow.
export const Bar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px 24px;
  flex-wrap: wrap;

  ${MOBILE} {
    justify-content: center;
  }
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

export const Caption = styled(Text)`
  font-size: 13px;
  color: ${PLAYERS.pageMeta};
  white-space: nowrap;
`;

export const SizeWrap = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: ${PLAYERS.pageMeta};
  white-space: nowrap;
  cursor: pointer;
`;

export const SelectBox = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

export const Select = styled.select`
  appearance: none;
  -webkit-appearance: none;
  height: 48px;
  padding: 0 36px 0 14px;
  border-radius: 12px;
  border: 1px solid ${PLAYERS.pageBorder};
  background: ${PLAYERS.pageBg};
  color: ${PLAYERS.searchText};
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  outline: none;
  transition: border-color ${ANIM.INTERACT_MS}ms ease, background ${ANIM.INTERACT_MS}ms ease;

  &:hover {
    background: ${PLAYERS.pageHoverBg};
  }
  &:focus-visible {
    border-color: ${PLAYERS.searchFocusBorder};
  }
`;

export const SelectChevron = styled.span`
  position: absolute;
  right: 12px;
  display: inline-flex;
  align-items: center;
  pointer-events: none;
  color: ${PLAYERS.searchIcon};
`;

export const Pager = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

// Page number chip — 48×48 minimum, solid brand-orange when it's the active page.
export const PageBtn = styled.button<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  height: 48px;
  padding: 0 14px;
  border-radius: 12px;
  font-family: inherit;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid ${(p) => (p.$active ? PLAYERS.pageActiveBg : PLAYERS.pageBorder)};
  background: ${(p) => (p.$active ? PLAYERS.pageActiveBg : PLAYERS.pageBg)};
  color: ${(p) => (p.$active ? PLAYERS.pageActiveText : PLAYERS.pageText)};
  transition: background ${ANIM.INTERACT_MS}ms ease, border-color ${ANIM.INTERACT_MS}ms ease,
    color ${ANIM.INTERACT_MS}ms ease;

  &:hover:not(:disabled) {
    background: ${(p) => (p.$active ? PLAYERS.pageActiveBg : PLAYERS.pageHoverBg)};
  }
  &:focus-visible {
    outline: none;
    border-color: ${PLAYERS.searchFocusBorder};
  }
  &:disabled {
    color: ${PLAYERS.pageDisabled};
    cursor: not-allowed;
  }
`;

// Square prev / next chevron buttons (no horizontal padding → exactly 48×48).
export const NavBtn = styled(PageBtn)`
  width: 48px;
  padding: 0;
`;

export const PageLabel = styled(Text)`
  line-height: 1;
`;

// Rotates the shared `arrow-left` glyph into a right-pointing "next" chevron.
export const Flip = styled.span`
  display: inline-flex;
  transform: rotate(180deg);
`;

export const Ellipsis = styled(Text)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 48px;
  color: ${PLAYERS.pageMeta};
  user-select: none;
`;
